import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showDeviationGroupListPopup } from './redux/actionCreators';
import { getDeviationTitle } from '../DeviationViews/_helpers';
export default function useDeviationGroupListPopup(deviation) {
    var _deviation_extended;
    const { deviationId  } = deviation;
    const title = getDeviationTitle(deviation);
    const url = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.groupListUrl;
    const dispatch = useDispatch();
    const dispatchedShowDeviationGroupListPopup = useCallback(()=>{
        dispatch(showDeviationGroupListPopup({
            deviationId,
            url,
            title
        }));
    }, [
        dispatch,
        deviationId,
        url,
        title
    ]);
    return dispatchedShowDeviationGroupListPopup;
}
